module.exports = __webpack_public_path__ + "static/media/33.50b9d278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/33.jpg
// module id = 208
// module chunks = 0